import { getUserInfo } from "../../userInfo";
import type { EventContext, InitialConfig } from "@src/types";
import type {
  MetaRegionContext,
  MetaPromotionNameContext,
  MetaCreativeSlotContext,
  MetaCreativeNameContext,
  MetaContentTypeContext,
  MetaSlotPerLineContext,
  MetaSearchTermContext,
  MetaSearchFoundContext,
  MetaSearchQuantityContext,
  MetaColorContext,
  MetaPriceRangeContext,
  MetaSizeContext,
  MetaOrderingContext,
  MetaCategoryContext,
  MetaItemRefContext,
  MetaMethodContext,
  MetaTypeContext,
  MetaBrandContext,
} from './types'


export const metaAdapter = {
  user_info: getUserInfo,
  brand: (context: MetaBrandContext, config: InitialConfig): string | null => {
    if (config?.brand) return config.brand
    if (context?.meta.brand) return context.meta.brand

    return null
  },

  content_type: (context: MetaContentTypeContext) => {
    return context.meta.content_type || null;
  },

  region: (context: MetaRegionContext) => {
    return context.meta.region || null;
  },

  pre_filled: (context: EventContext): boolean => {
    return !!context.preFilled;
  },

  currency: (_: EventContext, config: InitialConfig): string | null => {
    if (config?.currency) return config.currency
    return 'BRL'
  },

  slot_per_line: (context: MetaSlotPerLineContext): number | null => {
    return context.meta.slot_per_line ?? null;
  },

  search_term: (context: MetaSearchTermContext) => {
    return context.meta.search_term || null;
  },

  search_found: (context: MetaSearchFoundContext): boolean | null => {
    return context.meta.search_found || false
  },

  search_quantity: (context: MetaSearchQuantityContext): number | null => {
    return context.meta.search_quantity || 0;
  },

  promotion_name: (context: MetaPromotionNameContext) => {
    return context.meta.promotion_name || null;
  },

  creative_name: (context: MetaCreativeNameContext) => {
    return context.meta.creative_name || null;
  },

  creative_slot: (context: MetaCreativeSlotContext) => {
    return context.meta.creative_slot || null;
  },

  item_ref: (context: MetaItemRefContext) => {
    return context.meta.item_ref || null;
  },

  method: (context: MetaMethodContext) => {
    return context.meta.method || null;
  },

  type: (context: MetaTypeContext) => {
    return context.meta.type || null;
  },

  color: (context: MetaColorContext) => {
    return context.meta.color || null;
  },

  price_range: (context: MetaPriceRangeContext) => {
    return context.meta.price_range || null;
  },

  category: (context: MetaCategoryContext) => {
    return context.meta.category || null;
  },

  ordering: (context: MetaOrderingContext) => {
    return context.meta.ordering || null;
  },

  size: (context: MetaSizeContext) => {
    return context.meta.size || null;
  },
}